$(function () {
  if (!customElements.get('home-user-events')) {
    customElements.define(
      'home-user-events',
      class HomeUserEvent extends HTMLElement {
        constructor() {
          super();
          window.litime.ModalControllerState = window.litime.ModalControllerState || new ModalController();
          this.modalManager = window.litime.ModalControllerState;
        }
        connectedCallback() {
          this.init();
        }
        init() {
          const $root = $(this);
          $root.on('click', '.home-user-events__block', this.handleBlockClick.bind(this));
        }
        handleBlockClick(event) {
          const $block = $(event.currentTarget);
          const modalId = $block.data('id');
          const type = $block.data('type');
          // 检查是否已注册
          if (!this.modalManager.getModal(modalId)) {
            // 只在第一次时注册
            this.modalManager.register(modalId, {
              onOpen: (container) => {
                if (type === 'competition') {
                  this.initCompetitionModal(container);
                  this.initMobileCompetitionModal(container);
                }
              },
              onClose: () => {
                if (type === 'competition') {
                  this.unloadCompetitionModal();
                  this.unloadMobileCompetitionModal();
                }
              },
            });
          }
          // 打开弹窗
          this.modalManager.open(modalId);
        }
        initCompetitionModal(container) {
          this.currentIndex = 0;
          this.isScrolling = false;
          const root = $(container);
          this.$timeline = root.find('.home-competition-modal__timeline');
          this.$timelineContent = this.$timeline.find('.home-competition-modal__timeline_content');
          this.$yearGroup = this.$timeline.find('.home-competition-modal__timeline_year_group');
          this.$years = this.$timeline.find('.home-competition-modal__timeline_year');
          this.$events = this.$timeline.find('.home-competition-modal__timeline_event_item');
          this.$gallerys = root.find('.home-competition-modal__gallery');
          this.swipers = new Map();

          if (this.$events.length && this.$gallerys.length) {
            this.initTimeline(0);
            this.initSwiper(0, true);
          }
        }
        async initSwiper(index, isInit = false) {
          const targetGallery = this.$gallerys.eq(index);
          const eventId = this.$events[index].dataset.id;

          // 隐藏当前显示的gallery
          this.$gallerys.filter('[data-active="true"]').attr('data-active', 'false');
          // 重置目标gallery的位置
          gsap.set(targetGallery[0], {
            y: '30%',
            opacity: 0,
          });
          targetGallery.attr('data-active', 'true');

          // 初始化或获取swiper实例
          let swiper = this.swipers.get(eventId);

          if (!swiper) {
            const galleryMain = targetGallery.find('.home-competition-modal__gallery_swiper')[0];
            const galleryThumbs = targetGallery.find('.home-competition-modal__gallery_swiper_thumbs')[0];

            const thumbs = new Swiper(galleryThumbs, {
              spaceBetween: 24,
              slidesPerView: 'auto',
              freeMode: true,
              watchSlidesProgress: true,
            });
            swiper = new Swiper(galleryMain, {
              loop: true,
              effect: 'fade',
              fadeEffect: {
                crossFade: true,
              },
              autoplay: {
                delay: 5000,
                disableOnInteraction: false,
              },
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              thumbs: {
                swiper: thumbs,
              },
            });
            this.swipers.set(eventId, swiper);
          }
          swiper.slideTo(0, 0, false);

          // 执行入场动画
          gsap.to(targetGallery[0], {
            duration: isInit ? 0 : 0.3,
            y: '0%',
            opacity: 1,
          });
        }
        initTimeline(index) {
          if (this.$timelineContent) {
            this.$timelineContent.scrollTop(0);
          }
          this.$events.each((_, event) => {
            event.setAttribute('data-active', 'false');
          });
          if (this.$events[index]) {
            this.$events[index].setAttribute('data-active', 'true');
          }
          this.$yearGroup.attr('data-active', 'false');
          const firstYear = $(this.$events[index]).data('year');
          if (firstYear) {
            this.$yearGroup.filter(`[data-year="${firstYear}"]`).attr('data-active', 'true');
          }

          const $wrapper = this.$timeline.find('.home-competition-modal__timeline_wrapper');
          const wrapperHeight = $wrapper.height();
          this.$timelineContent.css('padding-bottom', `${wrapperHeight}px`);
          this.$timeline[0].addEventListener('wheel', this.handleWheel.bind(this), { passive: false });

          this.$years.on('click', this.handleYearClick.bind(this));
          this.$events.on('click', this.handleEventClick.bind(this));
        }

        handleWheel(e) {
          e.preventDefault();
          if (this.isScrolling) return;

          const direction = e.deltaY > 0 ? 1 : -1;
          const nextIndex = this.currentIndex + direction;
          this.handleToggle(nextIndex);
        }
        handleYearClick(event) {
          if (this.isScrolling) return;
          const yearValue = event.currentTarget.innerText.trim();
          const targetIndex = Array.from(this.$events).findIndex((event) => event.dataset.year === yearValue);
          if (targetIndex !== -1) {
            this.handleToggle(targetIndex);
          }
        }
        handleEventClick(event) {
          if (this.isScrolling) return;
          const targetIndex = Array.from(this.$events).findIndex((item) => item === event.currentTarget);

          if (targetIndex !== -1) {
            this.handleToggle(targetIndex);
          }
        }
        async handleToggle(targetIndex) {
          if (targetIndex === this.currentIndex || targetIndex < 0 || targetIndex >= this.$events.length) return;

          this.isScrolling = true;
          const currentEvent = $(this.$events[this.currentIndex]);
          const targetEvent = $(this.$events[targetIndex]);
          const currentYear = currentEvent.attr('data-year');
          const targetYear = targetEvent.attr('data-year');

          // 移除当前活动状态
          currentEvent.attr('data-active', 'false');

          // 如果年份改变，更新年份活动状态
          if (currentYear !== targetYear) {
            this.$yearGroup.filter(`[data-year="${currentYear}"]`).attr('data-active', 'false');
            this.$yearGroup.filter(`[data-year="${targetYear}"]`).attr('data-active', 'true');
          }

          // 计算滚动位置
          const contentRect = this.$timelineContent[0].getBoundingClientRect();
          const targetEventRect = targetEvent[0].getBoundingClientRect();
          const scrollTop = this.$timelineContent.scrollTop() + (targetEventRect.top - contentRect.top);

          // 更新状态
          targetEvent.attr('data-active', 'true');
          this.currentIndex = targetIndex;

          // 同时执行滚动动画和gallery切换
          await Promise.all([
            this.initSwiper(targetIndex),
            gsap.to(this.$timelineContent[0], {
              duration: 0.3,
              scrollTop: scrollTop,
            }),
          ]);

          this.isScrolling = false;
        }
        // 移动端初始化
        initMobileCompetitionModal(container) {
          this.yearIndex = 0;
          this.isToggling = false;
          const root = $(container);
          this.$mobileYears = root.find('.home-competition-modal__mobile_timeline_year');
          this.$mobileEvents = root.find('.home-competition-modal__mobile_timeline_event');

          this.mobileSwipers = new Map();

          if (this.$mobileYears.length) {
            this.initMobileTimeline(0);
            this.initMobileSwiper(0, true);
          }
        }
        initMobileTimeline(index) {
          this.$mobileYears.each((_, year) => {
            year.setAttribute('data-active', 'false');
          });
          $(this.$mobileYears[index]).attr('data-active', 'true');
          this.$mobileYears.on('click', this.handleMobileYearClick.bind(this));
        }
        initMobileSwiper(index, isInit = false) {
          const year = $(this.$mobileYears[index]).attr('data-year');
          const events = this.$mobileEvents.filter(`[data-year="${year}"]`);

          this.$mobileEvents.filter('[data-active="true"]').attr('data-active', 'false');

          events.attr('data-active', 'true');

          events.each((_, event) => {
            gsap.set(event, {
              x: index < this.yearIndex ? '-30%' : '30%',
              opacity: 0,
            });
            const eventId = $(event).attr('data-id');
            let swiper = this.mobileSwipers.get(eventId);
            if (!swiper) {
              const swiperEle = $(event).find('.home-competition-modal__mobile_gallery_swiper')[0];
              const $pagination = $(event).find('.swiper-pagination');
              const $slides = $(event).find('.swiper-slide');
              swiper = new Swiper(swiperEle, {
                loop: true,
                effect: 'fade',
                fadeEffect: {
                  crossFade: true,
                },
                autoplay: {
                  delay: 5000,
                  disableOnInteraction: false,
                },
                pagination: {
                  el: '.swiper-pagination',
                  clickable: true,
                },
                on: {
                  autoplayTimeLeft(_s, _time, progress) {
                    requestAnimationFrame(() => {
                      $pagination.css('--progress', `${(1 - progress) * 100}%`);
                    });
                  },
                },
              });
              if ($slides.length <= 1) {
                swiper.disable();
              }
              this.mobileSwipers.set(eventId, swiper);
            }
            swiper.slideTo(0, 0, false);
            gsap.to(event, {
              duration: isInit ? 0 : 0.3,
              x: '0%',
              opacity: 1,
            });
          });
        }
        async handleMobileYearClick(event) {
          if (this.isToggling) return;

          // 居中滚动
          const scrollEle = event.currentTarget.parentElement;
          const scrollRect = scrollEle.getBoundingClientRect();
          const yearRect = event.currentTarget.getBoundingClientRect();
          const scrollValue =
            scrollEle.scrollLeft + yearRect.left - scrollRect.left - (scrollRect.width - yearRect.width) / 2;

          scrollEle.scrollTo({
            left: scrollValue,
            behavior: 'smooth',
          });

          // 状态切换
          const targetIndex = Array.from(this.$mobileYears).findIndex((item) => item === event.currentTarget);
          if (targetIndex === this.yearIndex || targetIndex < 0 || targetIndex >= this.$mobileYears.length) return;
          this.isToggling = true;

          $(this.$mobileYears[this.yearIndex]).attr('data-active', 'false');
          $(this.$mobileYears[targetIndex]).attr('data-active', 'true');

          await this.initMobileSwiper(targetIndex);
          this.yearIndex = targetIndex;
          this.isToggling = false;
        }
        // 卸载弹窗
        unloadCompetitionModal() {
          // 注销事件
          this.$timeline[0].removeEventListener('wheel', this.handleWheel.bind(this), { passive: false });
          this.$years.off('click', this.handleYearClick.bind(this));
          this.$events.off('click', this.handleEventClick.bind(this));

          this.swipers.forEach((swiper) => {
            if (swiper && !swiper.destroyed) {
              swiper.destroy();
            }
          });
          this.swipers.clear();
        }
        unloadMobileCompetitionModal() {
          this.$mobileYears.off('click', this.handleMobileYearClick.bind(this));

          this.mobileSwipers.forEach((swiper) => {
            if (swiper && !swiper.destroyed) {
              swiper.destroy();
            }
          });
          this.mobileSwipers.clear();
        }
      }
    );
  }
});
